import React from 'react';
interface Props {
  size?: number;
  className?: string;
}
export function LogoMark({
  size = 32,
  className = ''
}: Props) {
  return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="Masube" data-id="element-274">
      <rect width="40" height="40" rx="11" fill="#2BE38C" data-id="element-275" />
      {/* Stylised "M" / settle glyph in ink */}
      <path d="M11 28V13.5C11 12.6716 11.6716 12 12.5 12C13.0095 12 13.4842 12.2589 13.7603 12.6873L20 22.3L26.2397 12.6873C26.5158 12.2589 26.9905 12 27.5 12C28.3284 12 29 12.6716 29 13.5V28" stroke="#0E0F10" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-276" />
      <circle cx="20" cy="27.5" r="2.4" fill="#0E0F10" data-id="element-277" />
    </svg>;
}